import React, { FC, memo } from "react";

import useStyles from "./styles";
interface Props {
  address: string;
}
const Address: FC<Props> = memo(({ address }) => {
  const classes = useStyles();
  return (
    <>
      {/* <p style={{ lineHeight: 1.5 }}>
        <strong>
          {firstname} {lastname}
        </strong>{" "}
      </p> */}
      {/* <Box mb={1}>{telephone}</Box> */}
      <div>
        {/* {company && <p>{company}</p>} */}
        <p className={classes.addressTypo}>{address}</p>
        {/* {vat_id && (
          <p style={{ lineHeight: 1.5 }}>
            <FormattedMessage
              id={"checkoutPage.taxNo"}
              defaultMessage={"Tax No."}
            />{" "}
            {vat_id}
          </p>
        )} */}
      </div>
    </>
  );
});

export default Address;
